module.exports = __webpack_public_path__ + "static/img/international-certification.83512bd1.png";